import { useResourceContext } from 'ra-core'
import { APIEntity } from 'services/api/entities'

export const useKResource = <T extends APIEntity>() => useResourceContext() as T
